export enum VisitTypeId {
    RGRL = 458
}

export const VISIT_TYPE_DISPLAY_NAME_OVERRIDES: Record<number, string> = {
    [VisitTypeId.RGRL]: 'RGRL/RRL'
};
